import { BlobToUint8, Uint8ToBlob } from "@pdfking/tfunc"

import { BytesToPdf } from "../utils/BytesToPdf"

export async function ImageToPdf(
  blob: Blob,
  image_resolution: number
): Promise<Blob> {
  const pdf = await BytesToPdf(
    await BlobToUint8(blob),
    blob.type,
    image_resolution
  )

  return pdf.save().then(bytes => Uint8ToBlob(bytes, "application/pdf"))
}
